<template>
  <div class="chart-header">
    <h4 :class="getTabClass('income')" @click="changeTab('income')">{{$t('stats.income')}}</h4>
    <h4 v-if="!hideActivityTab" @click="changeTab('activity')" :class="getTabClass('activity')">{{$t('stats.activity')}}</h4>
    <h4 v-if="showClientsTab" :class="getTabClass('clients')" @click="changeTab('clients')">{{$t('stats.guests')}}</h4>
    <h4 class="dropdown" @click="toggleDropdown()">
      {{$t('stats.data_for')}}:
      <span v-if="selectedRange == 'week'">{{$t('stats.week')}}<img src="../../assets/arrow.svg" alt=""> </span>
      <span v-if="selectedRange == 'two_weeks'">{{$t('stats.two_weeks')}}<img src="../../assets/arrow.svg" alt=""> </span>
      <span v-if="selectedRange == 'month'">{{$t('stats.month')}}<img src="../../assets/arrow.svg" alt=""> </span>
    </h4>
    <div id="myDropdown" v-if="activeDropdown" class="position-relative">
      <div class="dropdown-content">
        <span @click="changeRange('week')">{{$t('stats.week')}}</span>
        <span @click="changeRange('two_weeks')">{{$t('stats.two_weeks')}}</span>
        <span @click="changeRange('month')">{{$t('stats.month')}}</span>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  props: ["showClientsTab", 'currentTab', 'hideActivityTab'],
  data() {
    return {
      activeDropdown: false,
      selectedRange: 'week'
    };
  },
  methods: {
    getTabClass(tab) {
      return {
        active : this.currentTab == tab
       }
    },
    toggleDropdown() {
      this.activeDropdown = !this.activeDropdown;
    },
    changeTab(newTab) {
      this.$emit('changeTab', newTab);
    },
    changeRange(new_range) {
      this.selectedRange = new_range;
      this.$emit('changeRange', new_range);
      this.toggleDropdown();
    },
    setUiRange(new_range) {
      this.selectedRange = new_range;
    }
  }
};
</script>

<style scoped>
.chart-header {
  width: 117vh;
  display: flex;
  border-bottom: 1px solid #c4c4c4;
  border-radius: 1vh 1vh 0 0;
  margin-top: 2.2vh;
  background: #1d1d1b;
}

.chart-header h4 {
  cursor: pointer;
  padding: 2vh 3vh 2vh 3vh;
  color: #a4a3a1;
  margin-bottom: -0.3vh;
  z-index: 1;
  font-size: 1.8vh;
}

h4 span {
  color: #ededed;
}

.dropdown-content {
  background: #1d1d1d;
  color: #ededed;
  position: absolute;
  top: 5.5vh;
  width: 15vh;
  border-radius: 1vh;
  box-shadow: 2px 2px 2px #000000;
  right: -5vh;
  z-index: 10;
}

.dropdown-content span {
  font-size: 2.2vh;
  padding: 1vh;
  display: block;
  transition: 0.3s;
  cursor: pointer;
}

.dropdown-content span {
  border-radius: 1vh 1vh 0 0;
  border-bottom:1px solid #c4c4c4;
}

.dropdown-content span:hover {
  background: rgba(0, 0, 0, 0.2);
}

.chart-header h4.dropdown {
  padding-left: 29vh;
}

h4.active {
  border-bottom: 5px solid #bde1e4;
  color: #ededed;
}

h3,
h4,
h5,
p {
  margin-bottom: 0;
}
</style>

